import React, { FC, useState } from 'react';

import FormField from 'common/components/base/form-field';
import Input from 'common/components/base/input';
import Label from 'common/components/base/label';
import FieldErrorList from '../field-error-list/FieldErrorList';
import { CategoryField, InputType } from 'common/enums';
import TextArea from 'common/components/base/text-area';
import { FieldError } from 'common/models';
import './SubcategoryForm.scss';
import { SubCategoryField } from 'common/enums/data.enum';

type SubcategoryFormProps = {
    fieldErrors: Array<FieldError>;
    handleNameChange: (event: any) => void;
    handleSortOrderChange: (value: string) => void;
    handleDescription: (event: any) => void;
    name: string;
    sortOrder: string;
    description: string;
};

const SubcategoryForm: FC<SubcategoryFormProps> = ({
    fieldErrors,
    name,
    handleNameChange,
    sortOrder,
    handleSortOrderChange,
    description,
    handleDescription
}) => {
    return (
        <>
            <div className="category-top-section">
                <FormField className="category-form-field">
                    <Label text="Name (required)"></Label>
                    <Input
                        type={InputType.TEXT}
                        value={name}
                        data-testid={'category-field-name'}
                        onChange={handleNameChange}
                    />
                    <FieldErrorList field={SubCategoryField.Name} errors={fieldErrors} />
                </FormField>
                <FormField className="category-form-field-right">
                    <Label text="Sort Order (required)"></Label>
                    <Input
                        type={InputType.TEXT}
                        value={sortOrder}
                        data-testid={'category-field-sort-order'}
                        onChange={(event: any) => handleSortOrderChange(event.target.value)}
                    />
                    <FieldErrorList field={SubCategoryField.SortOrder} errors={fieldErrors} />
                </FormField>
            </div>
            <FormField className="category-form-field">
                <Label text="Description"></Label>
                <TextArea
                    value={description}
                    data-testid={'category-field-description'}
                    onChange={handleDescription}
                />
                <FieldErrorList
                    field={SubCategoryField.Description}
                    errors={fieldErrors}
                    data-testid="error"
                />
            </FormField>
        </>
    );
};

export default SubcategoryForm;
